import React, { lazy } from 'react';
import { Section, AccordionItem, Button, Countdown } from './ui';
import { ShieldCheck, MessageCircle, Star, LayoutList, CheckCircle2, Clock } from 'lucide-react';
const CHECKOUT_URL = 'https://sistema-iphone-ads.myshopify.com/cart/add?id=46176935641285&quantity=1&return_to=/cart';
export const Testimonials = () => {
  const testimonials = [{
    text: 'Lo que más me sirvió fue entender que no necesitaba arrancar comprando varios equipos. Primero tenía que entender cómo vender por pedido y cómo moverme mejor.',
    author: 'Alumno del curso'
  }, {
    text: 'Antes pensaba que para empezar necesitaba stock. El curso me ordenó la cabeza y me mostró una forma más lógica de entrar al negocio.',
    author: 'Alumno del curso'
  }, {
    text: 'Me ayudó a ver qué errores evitar antes de poner plata en un iPhone. Eso solo ya me pareció clave.',
    author: 'Alumno del curso'
  }, {
    text: 'La parte de marketing me sirvió para entender cómo comunicar mejor y no depender solo de subir fotos a Instagram.',
    author: 'Alumno del curso'
  }, {
    text: 'Me gustó que no sea solo anuncios. También explica negocio, proveedores, venta por pedido y cómo pensar el rubro desde cero.',
    author: 'Alumno del curso'
  }, {
    text: 'Es simple, directo y va al punto. Te muestra qué mirar antes de comprar, cómo evitar errores y cómo empezar con más claridad.',
    author: 'Alumno del curso'
  }];
  // Duplicamos el array para lograr el efecto de loop infinito sin cortes
  const duplicatedTestimonials = [...testimonials, ...testimonials];
  return <Section className="bg-white/[0.02] border-y border-white/[0.05] backdrop-blur-sm overflow-hidden py-16" data-id="element-188">
      <div className="text-center mb-12 max-w-3xl mx-auto px-6" data-id="element-189">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-190">
          Lo que más valoran quienes empiezan con este sistema
        </h2>
        <p className="text-lg text-zinc-400" data-id="element-191">
          Una capacitación pensada para ordenar el negocio, evitar arrancar a
          ciegas y aprender a conseguir clientes.
        </p>
      </div>

      {/* Carrusel contenedor */}
      <div className="relative w-full flex overflow-hidden group" data-id="element-192">
        {/* Gradientes laterales para suavizar la entrada/salida */}
        <div className="absolute top-0 left-0 w-12 md:w-32 h-full bg-gradient-to-r from-zinc-950 to-transparent z-10 pointer-events-none" data-id="element-193"></div>
        <div className="absolute top-0 right-0 w-12 md:w-32 h-full bg-gradient-to-l from-zinc-950 to-transparent z-10 pointer-events-none" data-id="element-194"></div>

        {/* Pista animada */}
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused] gap-6 px-3" data-id="element-195">
          {duplicatedTestimonials.map((t, i) => <div key={i} className="w-[300px] md:w-[380px] bg-zinc-900/60 backdrop-blur-sm border border-white/[0.05] rounded-2xl p-6 flex flex-col shadow-lg hover:border-blue-500/30 transition-colors flex-shrink-0" data-id="element-196">
              <div className="flex space-x-1 mb-4" data-id="element-197">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-emerald-500 text-emerald-500" data-id="element-198" />)}
              </div>
              <p className="text-zinc-300 flex-1 mb-6 text-sm md:text-base leading-relaxed" data-id="element-199">
                "{t.text}"
              </p>
              <div className="flex items-center space-x-3" data-id="element-200">
                <div className="w-10 h-10 rounded-full bg-zinc-800 border border-white/[0.05] flex items-center justify-center" data-id="element-201">
                  <CheckCircle2 className="w-5 h-5 text-emerald-500" data-id="element-202" />
                </div>
                <span className="text-sm font-semibold text-zinc-400" data-id="element-203">
                  {t.author}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
};
export const CourseOrganization = () => {
  const cards = [{
    title: 'Cómo empezar sin stock',
    text: 'Vas a entender cómo moverte sin necesidad de comprar varios equipos desde el primer día.',
    img: 'https://images.unsplash.com/photo-1512054502232-10a0a035d672?q=80&w=600&fm=webp&auto=format&fit=crop'
  }, {
    title: 'Cómo evitar comprar mal',
    text: 'Vas a aprender qué mirar antes de poner plata en un equipo y cómo reducir errores comunes.',
    img: 'https://images.unsplash.com/photo-1585060544812-6b45742d762f?q=80&w=600&fm=webp&auto=format&fit=crop'
  }, {
    title: 'Cómo conseguir clientes',
    text: 'Vas a ver cómo usar contenido, Instagram, WhatsApp y anuncios para generar conversaciones comerciales.',
    img: 'https://images.unsplash.com/photo-1556656793-08538906a9f8?q=80&w=600&fm=webp&auto=format&fit=crop',
    chips: ['Instagram', 'WhatsApp', 'Meta Ads', 'Conversaciones']
  }, {
    title: 'Cómo vender por pedido',
    text: 'Vas a entender cómo funciona la lógica de vender sin tener todo el stock encima.',
    img: 'https://images.unsplash.com/photo-1605236453806-6ff36851218e?q=80&w=600&fm=webp&auto=format&fit=crop'
  }, {
    title: 'Cómo pensar modelos y demanda',
    text: 'Vas a tener más claridad sobre qué equipos mirar y cómo no quedarte con celulares parados.',
    img: 'https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?q=80&w=600&fm=webp&auto=format&fit=crop'
  }, {
    title: 'Cómo comunicar tus ofertas',
    text: 'Vas a aprender a mostrar equipos, precios y oportunidades de una forma más clara, simple y comercial.',
    img: 'https://images.unsplash.com/photo-1603302576837-37561b2e2302?q=80&w=600&fm=webp&auto=format&fit=crop',
    chips: ['Oferta', 'Precio', 'Modelo', 'WhatsApp']
  }];
  return <Section data-id="element-204">
      <div className="text-center mb-12" data-id="element-205">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-206">
          Qué vas a poder ordenar con este curso
        </h2>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-207">
        {cards.map((card, i) => <div key={i} className="bg-zinc-900/60 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-2xl overflow-hidden group hover:border-blue-500/50 transition-colors flex flex-col shadow-md md:shadow-xl h-full" data-id="element-208">
            {/* Image Container */}
            <div className="relative h-40 md:h-48 w-full overflow-hidden shrink-0" data-id="element-209">
              <img src={card.img} alt={card.title} loading="lazy" decoding="async" width="800" height="600" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-210" />
              <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-zinc-900/20 to-transparent" data-id="element-211"></div>

              {/* Optional Chips for specific cards */}
              {card.chips && <div className="absolute inset-0 flex flex-wrap items-center justify-center gap-2 p-4 bg-zinc-950/30" data-id="element-212">
                  {card.chips.map(chip => <span key={chip} className="bg-zinc-950/90 backdrop-blur-sm md:backdrop-blur-md border border-zinc-700/50 shadow-md text-[11px] font-semibold text-zinc-200 px-2.5 py-1 rounded-full" data-id="element-213">
                      {chip}
                    </span>)}
                </div>}
            </div>

            {/* Text Container */}
            <div className="p-6 pt-0 relative flex-1 flex flex-col" data-id="element-214">
              <div className="w-10 h-10 rounded-full bg-zinc-950 border border-white/[0.1] flex items-center justify-center -mt-5 mb-4 relative z-10 shadow-xl shrink-0" data-id="element-215">
                <LayoutList className="w-5 h-5 text-blue-500" data-id="element-216" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-217">
                {card.title}
              </h3>
              <p className="text-sm text-zinc-400 leading-relaxed flex-1" data-id="element-218">
                {card.text}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-white/[0.02] border-y border-white/[0.05] backdrop-blur-sm" data-id="element-219">
      <div className="max-w-3xl mx-auto text-center" data-id="element-220">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-500/10 mb-6" data-id="element-221">
          <ShieldCheck className="w-8 h-8 text-blue-500" data-id="element-222" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-223">
          Comprá con tranquilidad
        </h2>
        <p className="text-lg text-zinc-300 mb-4" data-id="element-224">
          Tenés <span className="font-bold text-white" data-id="element-225">7 días de garantía</span>{' '}
          para revisar el contenido y asegurarte de que sea para vos.
        </p>
        <p className="text-sm text-zinc-500 mb-8 max-w-xl mx-auto" data-id="element-226">
          La garantía aplica si no se consumió una parte significativa del curso
          ni se descargaron materiales internos.
        </p>
        <div className="p-6 bg-zinc-900/60 backdrop-blur-sm md:backdrop-blur-md rounded-xl border border-white/[0.05] shadow-md md:shadow-xl" data-id="element-227">
          <p className="text-zinc-300 font-medium" data-id="element-228">
            "La idea es simple: queremos que entres porque realmente querés
            aprender, no porque sentís que estás arriesgando a ciegas."
          </p>
        </div>
      </div>
    </Section>;
};
export const HowItWorks = () => {
  const steps = ['Realizás el pago desde la landing.', 'Recibís las instrucciones de acceso.', 'Entrás al contenido digital del curso.', 'Podés avanzar a tu ritmo desde celular o computadora.', 'Si después querés acompañamiento, podés consultar las opciones grupal o personalizada.'];
  return <Section className="bg-white/[0.02] border-y border-white/[0.05] backdrop-blur-sm" data-id="element-229">
      <div className="max-w-4xl mx-auto" data-id="element-230">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 text-center" data-id="element-231">
          ¿Cómo funciona después de comprar?
        </h2>
        <div className="grid gap-4" data-id="element-232">
          {steps.map((step, i) => <div key={i} className="flex items-center p-4 md:p-5 bg-zinc-900/50 backdrop-blur-sm md:backdrop-blur-md rounded-xl border border-white/[0.05] shadow-sm md:shadow-lg" data-id="element-233">
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-emerald-500/10 mr-4 flex-shrink-0" data-id="element-234">
                <span className="text-emerald-500 font-bold" data-id="element-235">{i + 1}</span>
              </div>
              <p className="text-zinc-200 font-medium text-lg" data-id="element-236">{step}</p>
            </div>)}
        </div>
      </div>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Necesito tener stock para empezar?',
    a: 'No. Justamente una parte importante del curso explica cómo empezar sin stock propio y cómo vender por pedido.'
  }, {
    q: '¿Necesito tener una tienda de iPhones?',
    a: 'No. El curso también está pensado para personas que quieren empezar desde cero.'
  }, {
    q: '¿Necesito mucha plata para arrancar?',
    a: 'No necesitás empezar comprando muchos equipos. El curso te muestra cómo entender el negocio y cómo moverte antes de arriesgar tu capital.'
  }, {
    q: '¿El curso es solo de anuncios?',
    a: 'No. El curso une negocio, proveedores, logística, modelos, venta por pedido, marketing, contenido, anuncios y venta por conversación.'
  }, {
    q: '¿Qué incluye el precio de $19.000?',
    a: 'Incluye el acceso digital al curso grabado y sus materiales. No incluye acompañamiento grupal ni personalizado.'
  }, {
    q: '¿Cómo accedo después de comprar?',
    a: 'Después de realizar la compra, recibís las instrucciones de acceso al curso digital.'
  }, {
    q: '¿Puedo verlo desde el celular?',
    a: 'Sí. Podés acceder al contenido desde tu celular o computadora.'
  }, {
    q: '¿El curso garantiza resultados?',
    a: 'No. El curso te enseña la estructura, el negocio y las estrategias. Los resultados dependen de tu ejecución, tu mercado y cómo apliques lo aprendido.'
  }, {
    q: '¿Sirve si ya vendo iPhones?',
    a: 'Sí. También te puede servir si ya vendés, pero querés ordenar mejor tu forma de conseguir clientes y comunicar tus ofertas.'
  }, {
    q: '¿Después puedo pasar a acompañamiento?',
    a: 'Sí. Las opciones con acompañamiento grupal o personalizado se pueden consultar aparte.'
  }];
  return <Section data-id="element-237">
      <div className="max-w-3xl mx-auto" data-id="element-238">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 text-center" data-id="element-239">
          Preguntas Frecuentes
        </h2>
        <div className="bg-zinc-900/50 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-3xl p-4 md:p-8 shadow-md md:shadow-xl" data-id="element-240">
          {faqs.map((faq, i) => <AccordionItem key={i} question={faq.q} answer={faq.a} data-id="element-241" />)}
        </div>
      </div>
    </Section>;
};
export const FinalCTA = () => {
  return <Section className="pb-32 md:pb-24" data-id="element-242">
      <div className="max-w-4xl mx-auto rounded-3xl p-6 md:p-16 text-center relative overflow-hidden border border-white/[0.1] shadow-xl md:shadow-2xl" data-id="element-243">
        {/* Background Image */}
        <img src="https://images.unsplash.com/photo-1517336714731-489689fd1ca8?q=80&w=1200&fm=webp&auto=format&fit=crop" alt="Desk setup" loading="lazy" decoding="async" width="1600" height="900" className="absolute inset-0 w-full h-full object-cover" data-id="element-244" />

        {/* Dark Overlays */}
        <div className="absolute inset-0 bg-zinc-950/80" data-id="element-245"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/30 to-zinc-950/90" data-id="element-246"></div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-600/20 via-transparent to-transparent pointer-events-none" data-id="element-247"></div>

        <div className="relative z-10" data-id="element-248">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6" data-id="element-249">
            Últimos minutos para acceder con precio especial
          </h2>

          <p className="text-xl text-zinc-300 mb-8 max-w-2xl mx-auto" data-id="element-250">
            Antes de comprar tu primer equipo, antes de publicar cualquier cosa
            y antes de invertir plata sin saber, aprendé cómo funciona el
            negocio y cómo conseguir clientes.
          </p>

          <div className="space-y-8 relative z-10" data-id="element-251">
            <div className="flex items-center justify-center space-x-4" data-id="element-252">
              <span className="text-2xl md:text-3xl font-bold text-white" data-id="element-253">
                Hoy: $19.000
              </span>
              <span className="text-lg text-zinc-500 line-through" data-id="element-254">
                $40.000
              </span>
            </div>

            <div className="max-w-md mx-auto" data-id="element-255">
              <Countdown data-id="element-256" />
            </div>

            <div className="flex flex-col items-center space-y-4" data-id="element-257">
              <p className="text-sm md:text-base font-bold text-amber-300 max-w-md mx-auto" data-id="element-258">
                Quedan pocos minutos para acceder a $19.000 antes de que vuelva
                a $40.000.
              </p>
              <Button href={CHECKOUT_URL} className="w-full md:w-auto py-5 text-xl px-12 shadow-[0_0_30px_rgba(16,185,129,0.2)]" data-id="element-259">
                Quiero acceder por $19.000
              </Button>

              <p className="text-sm text-zinc-400" data-id="element-260">
                Después de esta cuenta regresiva, el acceso vuelve a $40.000.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
};